"use strict";
exports.__esModule = true;
var react_1 = require("react");
var styled_components_1 = require("styled-components");
function useTheme() {
    var theme = react_1.useContext(styled_components_1.ThemeContext);
    return theme || {};
}
exports["default"] = useTheme;
//# sourceMappingURL=useTheme.js.map